import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledTable,
  StyledHeaderRow,
  StyledDataRow,
  StyledCell,
  StyledCellText,
  StyledCellDescription,
  StyledSubRowList,
} from './index.style';

const CostTable = ({ rows, isMobile, headerName }) => {
  const { t } = useTranslation();
  const visibleRows = (rows || []).filter((row) => !row.hidden);

  return (
    <StyledTable $isMobile={isMobile}>
      <StyledHeaderRow>
        <StyledCell className="col-name is-header" $isMobile={isMobile}>
          <StyledCellText $isHeader>{headerName}</StyledCellText>
        </StyledCell>
        <StyledCell className="col-cost is-header" $isMobile={isMobile}>
          <StyledCellText $isHeader>
            {t('newCreditIntroColumnCost')}
          </StyledCellText>
        </StyledCell>
        {!isMobile && (
          <StyledCell
            className="col-description is-header"
            $isMobile={isMobile}
          >
            <StyledCellText $isHeader>{t('description')}</StyledCellText>
          </StyledCell>
        )}
      </StyledHeaderRow>

      {visibleRows.map((row) => (
        <StyledDataRow
          key={row.key}
          $isSubRow={row.isSubRow}
          $isMobile={isMobile}
        >
          <StyledCell
            className="col-name"
            $isMobile={isMobile}
            $isSubRow={row.isSubRow}
          >
            {row.isSubRow ? (
              <StyledSubRowList>
                <StyledCellText as="li">{row.name}</StyledCellText>
              </StyledSubRowList>
            ) : (
              <StyledCellText>{row.name}</StyledCellText>
            )}
            {isMobile && row.description && (
              <StyledCellDescription>{row.description}</StyledCellDescription>
            )}
          </StyledCell>

          <StyledCell className="col-cost" $isMobile={isMobile}>
            <StyledCellText
              $isItalic={row.isCostItalic}
              $isDim={row.isCostItalic}
            >
              {row.cost}
            </StyledCellText>
          </StyledCell>

          {!isMobile && (
            <StyledCell className="col-description" $isMobile={isMobile}>
              <StyledCellText>{row.description}</StyledCellText>
            </StyledCell>
          )}
        </StyledDataRow>
      ))}
    </StyledTable>
  );
};

export default CostTable;
